'use strict';

require("core-js/modules/esnext.global-this.js");

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var React = require('react');

var React__default = _interopDefault(React);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */


var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign.apply(this, arguments);
};

var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function unwrapExports(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}

var blocks = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.BLOCKS = void 0;
  /**
   * Map of all Contentful block types. Blocks contain inline or block nodes.
   */

  var BLOCKS;

  (function (BLOCKS) {
    BLOCKS["DOCUMENT"] = "document";
    BLOCKS["PARAGRAPH"] = "paragraph";
    BLOCKS["HEADING_1"] = "heading-1";
    BLOCKS["HEADING_2"] = "heading-2";
    BLOCKS["HEADING_3"] = "heading-3";
    BLOCKS["HEADING_4"] = "heading-4";
    BLOCKS["HEADING_5"] = "heading-5";
    BLOCKS["HEADING_6"] = "heading-6";
    BLOCKS["OL_LIST"] = "ordered-list";
    BLOCKS["UL_LIST"] = "unordered-list";
    BLOCKS["LIST_ITEM"] = "list-item";
    BLOCKS["HR"] = "hr";
    BLOCKS["QUOTE"] = "blockquote";
    BLOCKS["EMBEDDED_ENTRY"] = "embedded-entry-block";
    BLOCKS["EMBEDDED_ASSET"] = "embedded-asset-block";
    BLOCKS["EMBEDDED_RESOURCE"] = "embedded-resource-block";
    BLOCKS["TABLE"] = "table";
    BLOCKS["TABLE_ROW"] = "table-row";
    BLOCKS["TABLE_CELL"] = "table-cell";
    BLOCKS["TABLE_HEADER_CELL"] = "table-header-cell";
  })(BLOCKS || (exports.BLOCKS = BLOCKS = {}));
});
unwrapExports(blocks);
var blocks_1 = blocks.BLOCKS;
var inlines = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.INLINES = void 0;
  /**
   * Map of all Contentful inline types. Inline contain inline or text nodes.
   */

  var INLINES;

  (function (INLINES) {
    INLINES["HYPERLINK"] = "hyperlink";
    INLINES["ENTRY_HYPERLINK"] = "entry-hyperlink";
    INLINES["ASSET_HYPERLINK"] = "asset-hyperlink";
    INLINES["RESOURCE_HYPERLINK"] = "resource-hyperlink";
    INLINES["EMBEDDED_ENTRY"] = "embedded-entry-inline";
    INLINES["EMBEDDED_RESOURCE"] = "embedded-resource-inline";
  })(INLINES || (exports.INLINES = INLINES = {}));
});
unwrapExports(inlines);
var inlines_1 = inlines.INLINES;
var marks = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.MARKS = void 0;
  /**
   * Map of all Contentful marks.
   */

  var MARKS;

  (function (MARKS) {
    MARKS["BOLD"] = "bold";
    MARKS["ITALIC"] = "italic";
    MARKS["UNDERLINE"] = "underline";
    MARKS["CODE"] = "code";
    MARKS["SUPERSCRIPT"] = "superscript";
    MARKS["SUBSCRIPT"] = "subscript";
  })(MARKS || (exports.MARKS = MARKS = {}));
});
unwrapExports(marks);
var marks_1 = marks.MARKS;
var schemaConstraints = createCommonjsModule(function (module, exports) {
  var __spreadArray = commonjsGlobal && commonjsGlobal.__spreadArray || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
        if (!ar) ar = Array.prototype.slice.call(from, 0, i);
        ar[i] = from[i];
      }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
  };

  var _a;

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.V1_MARKS = exports.V1_NODE_TYPES = exports.TEXT_CONTAINERS = exports.HEADINGS = exports.CONTAINERS = exports.VOID_BLOCKS = exports.TABLE_BLOCKS = exports.LIST_ITEM_BLOCKS = exports.TOP_LEVEL_BLOCKS = void 0;
  /**
   * Array of all top level block types.
   * Only these block types can be the direct children of the document.
   */

  exports.TOP_LEVEL_BLOCKS = [blocks.BLOCKS.PARAGRAPH, blocks.BLOCKS.HEADING_1, blocks.BLOCKS.HEADING_2, blocks.BLOCKS.HEADING_3, blocks.BLOCKS.HEADING_4, blocks.BLOCKS.HEADING_5, blocks.BLOCKS.HEADING_6, blocks.BLOCKS.OL_LIST, blocks.BLOCKS.UL_LIST, blocks.BLOCKS.HR, blocks.BLOCKS.QUOTE, blocks.BLOCKS.EMBEDDED_ENTRY, blocks.BLOCKS.EMBEDDED_ASSET, blocks.BLOCKS.EMBEDDED_RESOURCE, blocks.BLOCKS.TABLE];
  /**
   * Array of all allowed block types inside list items
   */

  exports.LIST_ITEM_BLOCKS = [blocks.BLOCKS.PARAGRAPH, blocks.BLOCKS.HEADING_1, blocks.BLOCKS.HEADING_2, blocks.BLOCKS.HEADING_3, blocks.BLOCKS.HEADING_4, blocks.BLOCKS.HEADING_5, blocks.BLOCKS.HEADING_6, blocks.BLOCKS.OL_LIST, blocks.BLOCKS.UL_LIST, blocks.BLOCKS.HR, blocks.BLOCKS.QUOTE, blocks.BLOCKS.EMBEDDED_ENTRY, blocks.BLOCKS.EMBEDDED_ASSET, blocks.BLOCKS.EMBEDDED_RESOURCE];
  exports.TABLE_BLOCKS = [blocks.BLOCKS.TABLE, blocks.BLOCKS.TABLE_ROW, blocks.BLOCKS.TABLE_CELL, blocks.BLOCKS.TABLE_HEADER_CELL];
  /**
   * Array of all void block types
   */

  exports.VOID_BLOCKS = [blocks.BLOCKS.HR, blocks.BLOCKS.EMBEDDED_ENTRY, blocks.BLOCKS.EMBEDDED_ASSET, blocks.BLOCKS.EMBEDDED_RESOURCE];
  /**
   * Dictionary of all container block types, and the set block types they accept as children.
   *
   * Note: This does not include `[BLOCKS.DOCUMENT]: TOP_LEVEL_BLOCKS`
   */

  exports.CONTAINERS = (_a = {}, _a[blocks.BLOCKS.OL_LIST] = [blocks.BLOCKS.LIST_ITEM], _a[blocks.BLOCKS.UL_LIST] = [blocks.BLOCKS.LIST_ITEM], _a[blocks.BLOCKS.LIST_ITEM] = exports.LIST_ITEM_BLOCKS, _a[blocks.BLOCKS.QUOTE] = [blocks.BLOCKS.PARAGRAPH], _a[blocks.BLOCKS.TABLE] = [blocks.BLOCKS.TABLE_ROW], _a[blocks.BLOCKS.TABLE_ROW] = [blocks.BLOCKS.TABLE_CELL, blocks.BLOCKS.TABLE_HEADER_CELL], _a[blocks.BLOCKS.TABLE_CELL] = [blocks.BLOCKS.PARAGRAPH], _a[blocks.BLOCKS.TABLE_HEADER_CELL] = [blocks.BLOCKS.PARAGRAPH], _a);
  /**
   * Array of all heading levels
   */

  exports.HEADINGS = [blocks.BLOCKS.HEADING_1, blocks.BLOCKS.HEADING_2, blocks.BLOCKS.HEADING_3, blocks.BLOCKS.HEADING_4, blocks.BLOCKS.HEADING_5, blocks.BLOCKS.HEADING_6];
  /**
   * Array of all block types that may contain text and inline nodes.
   */

  exports.TEXT_CONTAINERS = __spreadArray([blocks.BLOCKS.PARAGRAPH], exports.HEADINGS, true);
  /**
   * Node types before `tables` release.
   */

  exports.V1_NODE_TYPES = [blocks.BLOCKS.DOCUMENT, blocks.BLOCKS.PARAGRAPH, blocks.BLOCKS.HEADING_1, blocks.BLOCKS.HEADING_2, blocks.BLOCKS.HEADING_3, blocks.BLOCKS.HEADING_4, blocks.BLOCKS.HEADING_5, blocks.BLOCKS.HEADING_6, blocks.BLOCKS.OL_LIST, blocks.BLOCKS.UL_LIST, blocks.BLOCKS.LIST_ITEM, blocks.BLOCKS.HR, blocks.BLOCKS.QUOTE, blocks.BLOCKS.EMBEDDED_ENTRY, blocks.BLOCKS.EMBEDDED_ASSET, inlines.INLINES.HYPERLINK, inlines.INLINES.ENTRY_HYPERLINK, inlines.INLINES.ASSET_HYPERLINK, inlines.INLINES.EMBEDDED_ENTRY, 'text'];
  /**
   * Marks before `superscript` & `subscript` release.
   */

  exports.V1_MARKS = [marks.MARKS.BOLD, marks.MARKS.CODE, marks.MARKS.ITALIC, marks.MARKS.UNDERLINE];
});
unwrapExports(schemaConstraints);
var schemaConstraints_1 = schemaConstraints.V1_MARKS;
var schemaConstraints_2 = schemaConstraints.V1_NODE_TYPES;
var schemaConstraints_3 = schemaConstraints.TEXT_CONTAINERS;
var schemaConstraints_4 = schemaConstraints.HEADINGS;
var schemaConstraints_5 = schemaConstraints.CONTAINERS;
var schemaConstraints_6 = schemaConstraints.VOID_BLOCKS;
var schemaConstraints_7 = schemaConstraints.TABLE_BLOCKS;
var schemaConstraints_8 = schemaConstraints.LIST_ITEM_BLOCKS;
var schemaConstraints_9 = schemaConstraints.TOP_LEVEL_BLOCKS;
var types = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
});
unwrapExports(types);
var nodeTypes = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
});
unwrapExports(nodeTypes);
var emptyDocument = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.EMPTY_DOCUMENT = void 0;
  /**
   * A rich text document considered to be empty.
   * Any other document structure than this is not considered empty.
   */

  exports.EMPTY_DOCUMENT = {
    nodeType: blocks.BLOCKS.DOCUMENT,
    data: {},
    content: [{
      nodeType: blocks.BLOCKS.PARAGRAPH,
      data: {},
      content: [{
        nodeType: 'text',
        value: '',
        marks: [],
        data: {}
      }]
    }]
  };
});
unwrapExports(emptyDocument);
var emptyDocument_1 = emptyDocument.EMPTY_DOCUMENT;
var helpers = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.isText = exports.isBlock = exports.isInline = void 0;
  /**
   * Tiny replacement for Object.values(object).includes(key) to
   * avoid including CoreJS polyfills
   */

  function hasValue(obj, value) {
    for (var _i = 0, _a = Object.keys(obj); _i < _a.length; _i++) {
      var key = _a[_i];

      if (value === obj[key]) {
        return true;
      }
    }

    return false;
  }
  /**
   * Checks if the node is an instance of Inline.
   */


  function isInline(node) {
    return hasValue(inlines.INLINES, node.nodeType);
  }

  exports.isInline = isInline;
  /**
   * Checks if the node is an instance of Block.
   */

  function isBlock(node) {
    return hasValue(blocks.BLOCKS, node.nodeType);
  }

  exports.isBlock = isBlock;
  /**
   * Checks if the node is an instance of Text.
   */

  function isText(node) {
    return node.nodeType === 'text';
  }

  exports.isText = isText;
});
unwrapExports(helpers);
var helpers_1 = helpers.isText;
var helpers_2 = helpers.isBlock;
var helpers_3 = helpers.isInline;
var dist = createCommonjsModule(function (module, exports) {
  var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function (o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);

    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = {
        enumerable: true,
        get: function get() {
          return m[k];
        }
      };
    }

    Object.defineProperty(o, k2, desc);
  } : function (o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
  });

  var __setModuleDefault = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function (o, v) {
    Object.defineProperty(o, "default", {
      enumerable: true,
      value: v
    });
  } : function (o, v) {
    o["default"] = v;
  });

  var __exportStar = commonjsGlobal && commonjsGlobal.__exportStar || function (m, exports) {
    for (var p in m) {
      if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
    }
  };

  var __importStar = commonjsGlobal && commonjsGlobal.__importStar || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) {
      if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }

    __setModuleDefault(result, mod);

    return result;
  };

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.helpers = exports.EMPTY_DOCUMENT = exports.MARKS = exports.INLINES = exports.BLOCKS = void 0;
  Object.defineProperty(exports, "BLOCKS", {
    enumerable: true,
    get: function get() {
      return blocks.BLOCKS;
    }
  });
  Object.defineProperty(exports, "INLINES", {
    enumerable: true,
    get: function get() {
      return inlines.INLINES;
    }
  });
  Object.defineProperty(exports, "MARKS", {
    enumerable: true,
    get: function get() {
      return marks.MARKS;
    }
  });

  __exportStar(schemaConstraints, exports);

  __exportStar(types, exports);

  __exportStar(nodeTypes, exports);

  Object.defineProperty(exports, "EMPTY_DOCUMENT", {
    enumerable: true,
    get: function get() {
      return emptyDocument.EMPTY_DOCUMENT;
    }
  });

  var helpers$1 = __importStar(helpers);

  exports.helpers = helpers$1;
});
unwrapExports(dist);
var dist_1 = dist.helpers;
var dist_2 = dist.EMPTY_DOCUMENT;
var dist_3 = dist.MARKS;
var dist_4 = dist.INLINES;
var dist_5 = dist.BLOCKS;

function appendKeyToValidElement(element, key) {
  if (React.isValidElement(element) && element.key === null) {
    return React.cloneElement(element, {
      key: key
    });
  }

  return element;
}

function nodeListToReactComponents(nodes, options) {
  return nodes.map(function (node, index) {
    return appendKeyToValidElement(nodeToReactComponent(node, options), index);
  });
}

function nodeToReactComponent(node, options) {
  var renderNode = options.renderNode,
      renderMark = options.renderMark,
      renderText = options.renderText,
      preserveWhitespace = options.preserveWhitespace;

  if (dist_1.isText(node)) {
    var nodeValue = renderText ? renderText(node.value) : node.value;

    if (preserveWhitespace) {
      // Preserve multiple spaces.
      nodeValue = nodeValue.replace(/ {2,}/g, function (match) {
        return "\xA0".repeat(match.length);
      }); // Preserve line breaks.

      var lines_1 = nodeValue.split('\n');
      var jsxLines_1 = [];
      lines_1.forEach(function (line, index) {
        jsxLines_1.push(line);

        if (index !== lines_1.length - 1) {
          jsxLines_1.push(React__default.createElement("br", null));
        }
      });
      nodeValue = jsxLines_1;
    }

    return node.marks.reduce(function (value, mark) {
      if (!renderMark[mark.type]) {
        return value;
      }

      return renderMark[mark.type](value);
    }, nodeValue);
  } else {
    var children = nodeListToReactComponents(node.content, options);

    if (!node.nodeType || !renderNode[node.nodeType]) {
      return React__default.createElement(React__default.Fragment, null, children);
    }

    return renderNode[node.nodeType](node, children);
  }
}

var _a, _b;

var defaultNodeRenderers = (_a = {}, _a[dist_5.DOCUMENT] = function (node, children) {
  return children;
}, _a[dist_5.PARAGRAPH] = function (node, children) {
  return React__default.createElement("p", null, children);
}, _a[dist_5.HEADING_1] = function (node, children) {
  return React__default.createElement("h1", null, children);
}, _a[dist_5.HEADING_2] = function (node, children) {
  return React__default.createElement("h2", null, children);
}, _a[dist_5.HEADING_3] = function (node, children) {
  return React__default.createElement("h3", null, children);
}, _a[dist_5.HEADING_4] = function (node, children) {
  return React__default.createElement("h4", null, children);
}, _a[dist_5.HEADING_5] = function (node, children) {
  return React__default.createElement("h5", null, children);
}, _a[dist_5.HEADING_6] = function (node, children) {
  return React__default.createElement("h6", null, children);
}, _a[dist_5.EMBEDDED_ENTRY] = function (node, children) {
  return React__default.createElement("div", null, children);
}, _a[dist_5.EMBEDDED_RESOURCE] = function (node, children) {
  return React__default.createElement("div", null, children);
}, _a[dist_5.UL_LIST] = function (node, children) {
  return React__default.createElement("ul", null, children);
}, _a[dist_5.OL_LIST] = function (node, children) {
  return React__default.createElement("ol", null, children);
}, _a[dist_5.LIST_ITEM] = function (node, children) {
  return React__default.createElement("li", null, children);
}, _a[dist_5.QUOTE] = function (node, children) {
  return React__default.createElement("blockquote", null, children);
}, _a[dist_5.HR] = function () {
  return React__default.createElement("hr", null);
}, _a[dist_5.TABLE] = function (node, children) {
  return React__default.createElement("table", null, React__default.createElement("tbody", null, children));
}, _a[dist_5.TABLE_ROW] = function (node, children) {
  return React__default.createElement("tr", null, children);
}, _a[dist_5.TABLE_HEADER_CELL] = function (node, children) {
  return React__default.createElement("th", null, children);
}, _a[dist_5.TABLE_CELL] = function (node, children) {
  return React__default.createElement("td", null, children);
}, _a[dist_4.ASSET_HYPERLINK] = function (node) {
  return defaultInline(dist_4.ASSET_HYPERLINK, node);
}, _a[dist_4.ENTRY_HYPERLINK] = function (node) {
  return defaultInline(dist_4.ENTRY_HYPERLINK, node);
}, _a[dist_4.RESOURCE_HYPERLINK] = function (node) {
  return defaultInlineResource(dist_4.RESOURCE_HYPERLINK, node);
}, _a[dist_4.EMBEDDED_ENTRY] = function (node) {
  return defaultInline(dist_4.EMBEDDED_ENTRY, node);
}, _a[dist_4.EMBEDDED_RESOURCE] = function (node, children) {
  return defaultInlineResource(dist_4.EMBEDDED_RESOURCE, node);
}, _a[dist_4.HYPERLINK] = function (node, children) {
  return React__default.createElement("a", {
    href: node.data.uri
  }, children);
}, _a);
var defaultMarkRenderers = (_b = {}, _b[dist_3.BOLD] = function (text) {
  return React__default.createElement("b", null, text);
}, _b[dist_3.ITALIC] = function (text) {
  return React__default.createElement("i", null, text);
}, _b[dist_3.UNDERLINE] = function (text) {
  return React__default.createElement("u", null, text);
}, _b[dist_3.CODE] = function (text) {
  return React__default.createElement("code", null, text);
}, _b[dist_3.SUPERSCRIPT] = function (text) {
  return React__default.createElement("sup", null, text);
}, _b[dist_3.SUBSCRIPT] = function (text) {
  return React__default.createElement("sub", null, text);
}, _b);

function defaultInline(type, node) {
  return React__default.createElement("span", {
    key: node.data.target.sys.id
  }, "type: ", node.nodeType, " id: ", node.data.target.sys.id);
}

function defaultInlineResource(type, node) {
  return React__default.createElement("span", {
    key: node.data.target.sys.urn
  }, "type: ", node.nodeType, " urn: ", node.data.target.sys.urn);
}
/**
 * Serialize a Contentful Rich Text `document` to React tree
 */


function documentToReactComponents(richTextDocument, options) {
  if (options === void 0) {
    options = {};
  }

  if (!richTextDocument) {
    return null;
  }

  return nodeToReactComponent(richTextDocument, {
    renderNode: _assign(_assign({}, defaultNodeRenderers), options.renderNode),
    renderMark: _assign(_assign({}, defaultMarkRenderers), options.renderMark),
    renderText: options.renderText,
    preserveWhitespace: options.preserveWhitespace
  });
}

exports.documentToReactComponents = documentToReactComponents;